module.exports = __webpack_public_path__ + "static/media/tc.94b3bd27.svg";